import { render, staticRenderFns } from "./PositionAdjust.vue?vue&type=template&id=043dec3c&scoped=true"
import script from "./PositionAdjust.vue?vue&type=script&lang=js"
export * from "./PositionAdjust.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043dec3c",
  null
  
)

export default component.exports